import React from "react";
import { fillSheetFromGeotab, clearDispatchValues } from "../utils/consolidationAutofill.js";
import { loadGeotabDay } from "./useGeotabDay.js";
import { geotabTruckOf } from "../utils/consolidationGeotabFill.js";

// « Remplir depuis Geotab » et « Vider les saisies » du relevé d'un chauffeur, après la fenêtre de confirmation.
export default function useConsolidationAutofill({ row, quantities, setRow, setQuantities, setDirty, setCalculation = () => {}, onEdit = () => {}, editable, geotabAllowed = true }) {
  const [missing, setMissing] = React.useState(0);
  const [confirming, setConfirming] = React.useState(false);
  const [busy, setBusy] = React.useState(false);
  const [error, setError] = React.useState("");
  const request = React.useRef(0);
  const reset = () => { request.current += 1; setBusy(false); setError(""); setConfirming(false); setMissing(0); };
  React.useEffect(() => {
    if (!editable) { request.current += 1; setBusy(false); setConfirming(false); }
    // Sans droit Geotab, seul un remplissage en cours s'arrête : « Vider les saisies » ne dépend que de l'écriture.
    else if (!geotabAllowed) { request.current += 1; setBusy(false); setConfirming(current => current === "fill" ? false : current); }
    return () => { request.current += 1; };
  }, [editable, geotabAllowed]);
  const apply = result => {
    setMissing(result.missing || 0);
    if (result.row !== row || result.quantities !== quantities) {
      onEdit();
      setRow(result.row); setQuantities(result.quantities); setDirty(true); setCalculation(null);
    }
  };
  const toggle = (next) => {
    if (!editable || busy || (next && !geotabAllowed)) return;
    setError("");
    setConfirming(next ? "fill" : "clear");
  };
  const confirm = async () => {
    if (!editable || busy) return;
    if (confirming === "fill") {
      if (!geotabAllowed) return;
      const token = ++request.current;
      setBusy(true); setError("");
      try {
        const data = await loadGeotabDay(row.dispatch_date, row.dispatch_period || "day");
        if (token !== request.current) return;
        apply(fillSheetFromGeotab(row, quantities, geotabTruckOf(data, row)));
        setConfirming(false);
      } catch (failure) {
        if (token === request.current) setError(failure.message || "Geotab est indisponible.");
      } finally { if (token === request.current) setBusy(false); }
      return;
    }
    if (confirming === "clear") apply(clearDispatchValues(row, quantities));
    setConfirming(false);
  };
  return { missing, confirming, busy, error, reset, toggle, confirm,
    cancel: () => { request.current += 1; setBusy(false); setError(""); setConfirming(false); } };
}
